import styled from "styled-components/macro";

/**
 * Nine fields, two-up where two fit.
 *
 * The two forms this replaces laid the same record out two different ways: one
 * stacked six fields in a single column at 56% of a percentage-width dialog,
 * the other spread nine across an antd `Row gutter={[40, 48]}` of three
 * `lg={8}` columns — a 40px gutter and 48px of row spacing, so a nine-field
 * form was as wide as the window and the fields were further from each other
 * than from anything else on screen.
 *
 * Two columns, and the long fields take a whole row: an account name, an
 * IBAN and either address read through a letterbox in a half-width cell. One
 * column on a phone. Same 18/24 gaps as every other form in the product.
 */
export const Grid = styled.div`
  display: grid;
  /**
   * TWO columns, stated, not auto-fit.
   *
   * auto-fit fitted three of them into the wide dialog, and a cell asking to
   * span two then spanned two OF THREE — so "Account holder's address" took
   * columns one and two and pushed "Bank name" into the third, and every row
   * after it landed somewhere it did not belong. A form's columns are a
   * decision, not a division.
   */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
  align-items: start;

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Cell = styled.div<{ $span?: number }>`
  min-width: 0;
  grid-column: ${({ $span }) => ($span ? `span ${$span}` : "auto")};

  /* A cell that spans two columns has nothing to span when there is only
     one. */
  @media (max-width: 560px) {
    grid-column: auto;
  }
`;
